"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.clear = clear;
exports.get = get;
exports.remove = remove;

var _obj = require("../obj.js");

/**
 * @module ol/proj/transforms
 */

/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */
var transforms = {};
/**
 * Clear the transform cache.
 */

function clear() {
  transforms = {};
}
/**
 * Registers a conversion function to convert coordinates from the source
 * projection to the destination projection.
 *
 * @param {import("./Projection.js").default} source Source.
 * @param {import("./Projection.js").default} destination Destination.
 * @param {import("../proj.js").TransformFunction} transformFn Transform.
 */


function add(source, destination, transformFn) {
  var sourceCode = source.getCode();
  var destinationCode = destination.getCode();

  if (!(sourceCode in transforms)) {
    transforms[sourceCode] = {};
  }

  transforms[sourceCode][destinationCode] = transformFn;
}
/**
 * Unregisters the conversion function to convert coordinates from the source
 * projection to the destination projection.  This method is used to clean up
 * cached transforms during testing.
 *
 * @param {import("./Projection.js").default} source Source projection.
 * @param {import("./Projection.js").default} destination Destination projection.
 * @return {import("../proj.js").TransformFunction} transformFn The unregistered transform.
 */


function remove(source, destination) {
  var sourceCode = source.getCode();
  var destinationCode = destination.getCode();
  var transform = transforms[sourceCode][destinationCode];
  delete transforms[sourceCode][destinationCode];

  if ((0, _obj.isEmpty)(transforms[sourceCode])) {
    delete transforms[sourceCode];
  }

  return transform;
}
/**
 * Get a transform given a source code and a destination code.
 * @param {string} sourceCode The code for the source projection.
 * @param {string} destinationCode The code for the destination projection.
 * @return {import("../proj.js").TransformFunction|undefined} The transform function (if found).
 */


function get(sourceCode, destinationCode) {
  var transform;

  if (sourceCode in transforms && destinationCode in transforms[sourceCode]) {
    transform = transforms[sourceCode][destinationCode];
  }

  return transform;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUdBOztBQUhBOzs7O0FBS0E7Ozs7QUFJQSxJQUFJQSxVQUFVLEdBQUcsRUFBakI7QUFFQTs7OztBQUdNLFNBQVVDLEtBQVYsR0FBZTtFQUNuQkQsVUFBVSxHQUFHLEVBQWI7QUFDRDtBQUVEOzs7Ozs7Ozs7O0FBUU0sU0FBVUUsR0FBVixDQUFjQyxNQUFkLEVBQXNCQyxXQUF0QixFQUFtQ0MsV0FBbkMsRUFBOEM7RUFDbEQsSUFBTUMsVUFBVSxHQUFHSCxNQUFNLENBQUNJLE9BQVAsRUFBbkI7RUFDQSxJQUFNQyxlQUFlLEdBQUdKLFdBQVcsQ0FBQ0csT0FBWixFQUF4Qjs7RUFDQSxJQUFJLEVBQUVELFVBQVUsSUFBSU4sVUFBaEIsQ0FBSixFQUFpQztJQUMvQkEsVUFBVSxDQUFDTSxVQUFELENBQVYsR0FBeUIsRUFBekI7RUFDRDs7RUFDRE4sVUFBVSxDQUFDTSxVQUFELENBQVYsQ0FBdUJFLGVBQXZCLElBQTBDSCxXQUExQztBQUNEO0FBRUQ7Ozs7Ozs7Ozs7O0FBU00sU0FBVUksTUFBVixDQUFpQk4sTUFBakIsRUFBeUJDLFdBQXpCLEVBQW9DO0VBQ3hDLElBQU1FLFVBQVUsR0FBR0gsTUFBTSxDQUFDSSxPQUFQLEVBQW5CO0VBQ0EsSUFBTUMsZUFBZSxHQUFHSixXQUFXLENBQUNHLE9BQVosRUFBeEI7RUFDQSxJQUFNRyxTQUFTLEdBQUdWLFVBQVUsQ0FBQ00sVUFBRCxDQUFWLENBQXVCRSxlQUF2QixDQUFsQjtFQUNBLE9BQU9SLFVBQVUsQ0FBQ00sVUFBRCxDQUFWLENBQXVCRSxlQUF2QixDQUFQOztFQUNBLElBQUksa0JBQVFSLFVBQVUsQ0FBQ00sVUFBRCxDQUFsQixDQUFKLEVBQXFDO0lBQ25DLE9BQU9OLFVBQVUsQ0FBQ00sVUFBRCxDQUFqQjtFQUNEOztFQUNELE9BQU9JLFNBQVA7QUFDRDtBQUVEOzs7Ozs7OztBQU1NLFNBQVVDLEdBQVYsQ0FBY0wsVUFBZCxFQUEwQkUsZUFBMUIsRUFBeUM7RUFDN0MsSUFBSUUsU0FBSjs7RUFDQSxJQUFJSixVQUFVLElBQUlOLFVBQWQsSUFBNEJRLGVBQWUsSUFBSVIsVUFBVSxDQUFDTSxVQUFELENBQTdELEVBQTJFO0lBQ3pFSSxTQUFTLEdBQUdWLFVBQVUsQ0FBQ00sVUFBRCxDQUFWLENBQXVCRSxlQUF2QixDQUFaO0VBQ0Q7O0VBQ0QsT0FBT0UsU0FBUDtBQUNEIiwibmFtZXMiOlsidHJhbnNmb3JtcyIsImNsZWFyIiwiYWRkIiwic291cmNlIiwiZGVzdGluYXRpb24iLCJ0cmFuc2Zvcm1GbiIsInNvdXJjZUNvZGUiLCJnZXRDb2RlIiwiZGVzdGluYXRpb25Db2RlIiwicmVtb3ZlIiwidHJhbnNmb3JtIiwiZ2V0Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9wcm9qL3RyYW5zZm9ybXMuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=